/**
 *  Include the Council Badge, with the associated name.
 *  Both the badge and name are optional as props.
 *
 *  CSS component: c-council-badge
 */
import * as React from "react";
import CouncilBadge from "src/components/general/CouncilBadge";

export interface ICouncilIdentityBadge {
  name: string;
  badge: number; 
  modifier?: string;
  hideBadge?: boolean; 
  hideName?: boolean;
  inverse?: boolean;
}

export default class CouncilIdentityBadge extends React.PureComponent<
  ICouncilIdentityBadge
> {
  public render() {
    const utilClasses = 'c-council-badge flex items-center';
    return (
      <div className={( ( this.props.modifier ) ? utilClasses + ' ' + this.props.modifier : utilClasses )}>
        {( this.props.badge && this.props.name && !this.props.hideBadge ) && (
          <div className="c-council-badge__badge font-normal text-base">
            <CouncilBadge
              ordinal={ this.props.badge }
              name={ this.props.name }
              size={ 40 }
              x={ 0 }
              y={ 0 }
              inverse={ ( this.props.inverse ) ? true : false }
            />
          </div>
        )}
        {( this.props.name && !this.props.hideName ) && (
          <span className="c-council-badge__heading">{ this.props.name }</span>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/general/CouncilIdentity.tsx